
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity-verification/risk-checks",
      function () {
        return require("private-next-pages/docs/identity-verification/risk-checks.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity-verification/risk-checks"])
      });
    }
  